<template>
  <div class="footer" id="common-footer"></div>
</template>
<script lang="js">
import { onMounted } from "vue";
export default {
  name: "CommonFooter",
  setup() {
    onMounted(() => {
      window.footer({ node: "common-footer", isNew: true });
    });
  },
};
</script>
<style lang="scss">
.footer {
  .width-1190 {
    width: 1260px;
  }
}
</style>
